import { observable, computed, action, reaction } from 'mobx'
import {
    ITroubleEvent,
    TroubleEvent,
} from '../Model/TroubleEvent'
import DateTimeHelper from '../Helpers/DateTimeHelper'
import { createStub } from '../Model/TroubleEventsTableItem'
import ActionsLocalService from '../Services/ActionsLocalService'
import { ExportType } from './ExportStore'

export default class EventsStore {

    @observable
    private pageCountAll: number = 0

    @observable
    private pageCountNEW: number = 0

    @observable
    private pageCountInProgress: number = 0

    @observable
    private _item: ITroubleEvent

    @computed
    public get getItem() {
        return this._item
    }

    @observable
    _itemsNew: Array<ITroubleEvent> = []

    @observable
    _itemsInProgress: Array<ITroubleEvent> = []

    @observable
    private _items: Array<ITroubleEvent> = []

    constructor() {
        this.setList([])
        this.setNewList([])
        this.setInProgressList([])

        reaction(
            () => this._items,
            _ => {
                let data = createStub(this._items)
                ActionsLocalService.getInstance().setExportData(ExportType.TroubleEventsList, data)
            }
        )

        reaction(
            () => this._itemsNew,
            _ => {
                let data = createStub(this._itemsNew)
                ActionsLocalService.getInstance().setExportData(ExportType.TroubleEventsListNew, data)
            }
        )

        reaction(
            () => this._itemsInProgress,
            _ => {
                let data = createStub(this._itemsInProgress)
                ActionsLocalService.getInstance().setExportData(ExportType.TroubleEventsListInProgress, data)
            }
        )
    }

    public static getInstance(): EventsStore {
        return this._instance || (this._instance = new this())
    }

    private static _instance: EventsStore

    @action.bound
    setList(list: Array<ITroubleEvent>) {
        this._items = list
    }

    @action.bound
    setNewList(list: Array<ITroubleEvent>) {
        this._itemsNew = list
    }

    @action.bound
    setInProgressList(list: Array<ITroubleEvent>) {
        this._itemsInProgress = list
    }

    @action.bound
    setPageCountAll(pageCount: number) {
        this.pageCountAll = pageCount
    }

    @computed
    get getPageCountAll() {
        return this.pageCountAll
    }

    @action.bound
    setPageCountInProgress(pageCount: number) {
        this.pageCountInProgress = pageCount
    }

    @computed
    get getPageCountInProgress() {
        return this.pageCountInProgress
    }

    @action.bound
    setPageCountNEW(pageCount: number) {
        this.pageCountNEW = pageCount
    }

    @computed
    get getPageCountNEW() {
        return this.pageCountNEW
    }

    @computed
    get getList() {
        return this._items
    }

    @computed
    get getNewList() {
        return this._itemsNew
    }

    @computed
    get getInProgressList() {
        return this._itemsInProgress
    }

    @action.bound
    setItem(e: TroubleEvent) {
        if (!e.id) {
            e.createDate = DateTimeHelper.formatDateForList(e.createDate)
        }

        this._item = e
    }
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/Stores/EventsStore.ts